import React, { useState, useEffect } from "react";
import "./css/Audit.css";
import useApi from "../../apiProvider";
import AuditTable from "./AuditTable";
// import { use } from "react";

const SiteStructureCircuitAudit = () => {
  const [auditData, setAuditData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    useApi.getSiteStructureCircuitAuditData().then((response) => {
      console.log("API response:", response);
      console.log("Mapped data for AuditTable:", response);
      const sortedData = Array.isArray(response)
        ? response.sort((a, b) => b.timestamp - a.timestamp)
        : [];
      setAuditData(sortedData);
      setLoading(false);
    });
  }, []);

  return (
    <div
      style={{
        padding: "20px",
        height: "calc(100vh - 140px)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          border: "2px solid #dee2e6",
          borderRadius: "8px",
          padding: "20px",
          width: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          backgroundColor: "white",
          minHeight: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            marginBottom: "10px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <h6 style={{ margin: 0 }}>Site/Structure/Circuit Audit</h6>
          </div>
        </div>

        <div
          className="audit-table-container"
          style={{ flex: 1, overflow: "auto", minHeight: 0 }}
        >
          {loading ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <span
                className="spinner-border"
                role="status"
                aria-hidden="true"
              ></span>
              <span style={{ marginLeft: "10px" }}>Loading audit data...</span>
            </div>
          ) : (
            <AuditTable
              data={auditData}
              showSiteId={true}
              objectType={"Site/Structure/Circuit"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SiteStructureCircuitAudit;
